import React, { useContext, useEffect, useState } from 'react';
import { FilterData, FilterSettings } from './map.interfaces';
import { FilterContext } from './mapFilter';

export interface IMapFilterToggle {
  filterData: FilterData | null;
}

const MapFilterToggle = ({ filterData }: IMapFilterToggle) => {
  const { activeFilters, setActiveFilters } =
    useContext<FilterSettings>(FilterContext);

  const [checked, setChecked] = useState(false);

  // ------------------------------------------------------
  // USE EFFECT - Check data and set default values
  // ------------------------------------------------------

  useEffect(() => {
    if (filterData) {
      setChecked(filterData.selected);
    }
  }, [filterData]);

  // ------------------------------------------------------
  // USE EFFECT - Check context if activefilters changes
  // ------------------------------------------------------

  useEffect(() => {
    if (activeFilters && filterData) {
      const isActiveFilter = activeFilters.some(
        (filterId) => filterId === filterData.id
      );

      setChecked(isActiveFilter);
    }
  }, [activeFilters]);

  // ------------------------------------------------------
  // HANDLE CHANGE CHECK - checked/unchecked button event
  // ------------------------------------------------------

  const handleChangeCheck = () => {
    const isChecked = checked ? false : true;
    updateContext(isChecked);
    setChecked(isChecked);
  };

  // ------------------------------------------------------
  // UPDATE CONTEXT - update activefilters array in context
  // ------------------------------------------------------

  const updateContext = (isChecked: boolean) => {
    if (filterData && activeFilters) {
      const filterIndex = activeFilters.findIndex(
        (filterId) => filterId == filterData.id
      );

      if (isChecked) {
        if (filterIndex < 0) {
          activeFilters.push(filterData.id);
          setActiveFilters([...activeFilters]);
        }
      } else {
        if (filterIndex >= 0) {
          activeFilters.splice(filterIndex, 1);
          setActiveFilters([...activeFilters]);
        }
      }
    }
  };

  // ------------------------------------------------------
  // JSX
  // ------------------------------------------------------

  return (
    <div className={`map-filter-toggle ${checked ? 'checked' : ''}`}>
      <label className="map-filter-dropdown-toggle-label">
        {filterData?.title}
        <input
          type="checkbox"
          defaultChecked={checked}
          onChange={handleChangeCheck}
        />
        <span className="custom-checkbox"></span>
      </label>
    </div>
  );
};

export default MapFilterToggle;
